(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/gameguide/assets/javascripts/collections/gameguides.js') >= 0) return;  svs.modules.push('/components/tur/gameguide/assets/javascripts/collections/gameguides.js');
(function(Backbone, _, svs) {
  'use strict';

  svs.tur = svs.tur || {};
  svs.tur.gameguide = svs.tur.gameguide || {};
  svs.tur.gameguide.Spelguider = Backbone.Collection.extend({
    url: function() {
      var urls = [],
        i;

      for (i = 0; i < this.gameGuides.length; i++) {
        urls.push(new svs.content.shared.ContentUrlBuilder('/id/' + this.gameGuides[i].article).build());
      }

      return svs.core.jupiter.url() + '/multifetch?urls=' + encodeURIComponent(urls.join('|'));
    },

    initialize: function(options) {
      this.gameGuides = options.guides;
      this.product = options.product;
      this.logger = options.logger;

      var collection = this;

      this.sync('read', this, {
        success: function(response) {
          svs.content.simple_article.contentLoader.prepareArticles(collection.parse(response), {}, function(err, articles) {
            collection.set(articles);
            collection.trigger('sync', collection);
          });
        }
      });
    },

    parse: function(response) {
      var articles = [],
        i;

      for (i = 0; i < response.responses.length; i++) {
        if (response.responses[i].error) {
          this.logger.error('Error fetching spelguide article', response.responses[i].error);
        } else if (!response.responses[i].result && !response.responses[i].result.length) {
          this.logger.error('Spelguide article not found', response.responses[i]);
        } else if (response.responses[i].result[0]) {
          articles.push(response.responses[i].result[0]);
        }
      }

      return articles;
    }
  });
})(Backbone, _, svs);


 })(window);